import React from 'react';

import {
  IncidentType,
  useDevice,
  useWithSupportCenter,
} from '@portals/api/organizations';
import { EntityAccess } from '@portals/framework/EntityAccess';
import { ReactComponent as ArrowUp } from '@portals/icons/linear/arrow-up.svg';
import { ReactComponent as CloseSquare } from '@portals/icons/linear/close-square.svg';
import { useOpenModal } from '@portals/redux';
import { RowMenuItem, RowMenuItems } from '@portals/table';
import { AccessLevelEnum, RowMenuWrapperType, RowType } from '@portals/types';

interface IncidentsRowMenuProps {
  row: RowType<IncidentType>;
  wrapperProps: RowMenuWrapperType;
}

function IncidentsRowMenu({ row, wrapperProps }: IncidentsRowMenuProps) {
  const {
    original: { description },
  } = row;
  const { menuRef } = wrapperProps;

  const openModal = useOpenModal();

  const withSupportCenter = useWithSupportCenter();
  const menuItems: Array<RowMenuItem> = [];

  const device = useDevice(row.original.device_id);

  if (device.isFetched && withSupportCenter) {
    menuItems.push({
      id: 'escalate',
      label: 'Escalate',
      Icon: ArrowUp,
      color: 'red',
      Wrapper: ({ children }) => (
        <EntityAccess
          id="escalate-incident"
          minLevel={AccessLevelEnum.Edit}
          entity={device.data}
        >
          {children}
        </EntityAccess>
      ),
      onClick: () => {
        openModal('CreateTicket', {
          device: device.data,
          description,
        });
        menuRef?.onClose?.();
      },
    });
  }

  menuItems.push({
    id: 'close',
    label: 'Close',
    Icon: CloseSquare,
    onClick: () => {
      openModal('CloseIncident', { incident: row.original });
      menuRef?.onClose?.();
    },
    Wrapper: ({ children }) => (
      <EntityAccess
        id="close-incident"
        minLevel={AccessLevelEnum.Edit}
        entity={device.data}
      >
        {children}
      </EntityAccess>
    ),
  });

  return (
    <RowMenuItems
      items={menuItems}
      isLoading={device.isLoading}
      wrapperProps={wrapperProps}
    />
  );
}

export default IncidentsRowMenu;
